'use client'
import type { ElementType } from 'react'

type ToggleDocumentAttributeType = (attribute: string, value: string, remove?: boolean, tag?: ElementType) => void

export const toggleDocumentAttribute: ToggleDocumentAttributeType = (attribute, value, remove, tag = 'html'): void => {
  if (document.body) {
    const element = document.getElementsByTagName(tag.toString())[0]
    const hasAttribute = element.getAttribute(attribute)
    if (remove && hasAttribute) element.removeAttribute(attribute)
    else element.setAttribute(attribute, value)
  }
}

export const getMetaVersion = (): string | null => {
  const el = document.querySelector<HTMLMetaElement>('meta[name="app-version"]');
  const version = el?.getAttribute('content');
  return version ?? null;
}